export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["admin/Account-Users-dark.png","admin/Account-user-light.png","admin/Action-1-icon.png","admin/Activity-Logs-light.png","admin/Activity-logs-dark.png","admin/Anxious.png","admin/Create-Post-btn-icon.png","admin/Dashboard-dark.png","admin/Dashboard-light.png","admin/Dashboard-vector-2.png","admin/Delete-icon.png","admin/Fine.png","admin/Happy.png","admin/Logo-white.png","admin/Neutral.png","admin/Practical-Tips-btn-icon.png","admin/Report-dark.png","admin/Report-light.png","admin/Roles-and-Permission-light.png","admin/Roles-and-permissions-dark.png","admin/System-Settings-dark.png","admin/System-Settings-light.png","admin/Upload-Video-btn-icon.png","admin/Upset.png","admin/User-Profile-Light.png","admin/User-profile-dark.png","admin/View-icon.png","admin/big_logo.png","admin/button-image.png","admin/card-footer.png","admin/close.png","admin/delete-blue.png","admin/down-arrow-light.png","admin/down-arrow.png","admin/edit-blue.png","admin/edit.png","admin/eye.png","admin/icon.png","admin/large-icon.png","admin/left-arrow.png","admin/login-page-image.png","admin/logo.png","admin/logout-light.png","admin/right-arrow.png","admin/search-icon.png","admin/user-mood-tracking-activities.png","admin/user-profile.png","admin/user-self-report.png","downloads/emv-sheets/Physical.zip","downloads/emv-sheets/Psychological.zip","downloads/emv-sheets/Social.zip","downloads/emv-sheets/Spiritual.zip","favicon.png","icons/arrow_down.png","icons/back.png","icons/book.png","icons/briefcase.png","icons/calendar.png","icons/elevate-logo.png","icons/emv-logo.png","icons/eye.png","icons/login.png","icons/modules/dashboard/add.png","icons/modules/dashboard/anxious.png","icons/modules/dashboard/blank.png","icons/modules/dashboard/happy.png","icons/modules/dashboard/neutral.png","icons/modules/dashboard/satisfied.png","icons/modules/dashboard/upset.png","icons/modules/history/add.png","icons/modules/history/anxious.png","icons/modules/history/left.png","icons/modules/history/neutral.png","icons/modules/history/right.png","icons/modules/history/satisfied.png","icons/modules/history/vertical_menu.png","icons/modules/modal-logo.png","icons/modules/mood-tracking/anxious.png","icons/modules/mood-tracking/done.png","icons/modules/mood-tracking/happy.png","icons/modules/mood-tracking/neutral.png","icons/modules/mood-tracking/progress-gray.png","icons/modules/mood-tracking/progress.png","icons/modules/mood-tracking/satisfied.png","icons/modules/mood-tracking/swipe1.png","icons/modules/mood-tracking/swipe2.png","icons/modules/mood-tracking/upset.png","icons/modules/profile/edit.png","icons/modules/profile/profile.png","icons/modules/questionnaire/front-desktop.png","icons/modules/questionnaire/front.png","icons/modules/questionnaire/progress-gray.png","icons/modules/questionnaire/progress.png","icons/modules/questionnaire/video1.png","icons/modules/questionnaire/video2.png","icons/modules/resources/InnerPeace.mp4","icons/modules/resources/InnerPeace.png","icons/modules/resources/ManageBurnout.mp4","icons/modules/resources/ManageBurnout.png","icons/modules/resources/StressRelief.mp4","icons/modules/resources/StressRelief.png","icons/modules/resources/download.png","icons/modules/resources/filter.png","icons/modules/resources/info1.png","icons/modules/resources/info2.png","icons/modules/resources/info3.png","icons/modules/resources/information1.png","icons/modules/resources/information2.png","icons/modules/resources/information3.png","icons/modules/resources/saved.png","icons/modules/resources/self-report/Anxiety-Relief.png","icons/modules/resources/self-report/Anxiety.png","icons/modules/resources/self-report/Burnout-Prevention.png","icons/modules/resources/self-report/Burnout.png","icons/modules/resources/self-report/Coping-Effectiveness.png","icons/modules/resources/self-report/EMV-logo.png","icons/modules/resources/self-report/Header-Graphics.png","icons/modules/resources/self-report/Improved-Coping.png","icons/modules/resources/self-report/Journal-Highlights.png","icons/modules/resources/self-report/Stress-Management.png","icons/modules/resources/self-report/Stress.png","icons/modules/resources/shortVideo1.png","icons/modules/resources/shortVideo2.png","icons/modules/resources/shortVideo3.png","icons/nav/Menu.png","icons/nav/dashboard.png","icons/nav/history.png","icons/nav/logout.png","icons/nav/mood_tracking.png","icons/nav/profile.png","icons/nav/questionnaire.png","icons/nav/resources.png","icons/profile.png","icons/user-login-emojis-original.png","icons/user-login-emojis.png"]),
	mimeTypes: {".png":"image/png",".zip":"application/zip",".mp4":"video/mp4"},
	_: {
		client: {start:"_app/immutable/entry/start.BWOzjsis.js",app:"_app/immutable/entry/app.C_hTjm5e.js",imports:["_app/immutable/entry/start.BWOzjsis.js","_app/immutable/chunks/BD-h4Ubw.js","_app/immutable/chunks/CBKI_OW7.js","_app/immutable/chunks/JVm4Wwq-.js","_app/immutable/entry/app.C_hTjm5e.js","_app/immutable/chunks/CBKI_OW7.js","_app/immutable/chunks/Bh4tpsL0.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js')),
			__memo(() => import('./nodes/8.js')),
			__memo(() => import('./nodes/9.js')),
			__memo(() => import('./nodes/10.js')),
			__memo(() => import('./nodes/11.js')),
			__memo(() => import('./nodes/12.js')),
			__memo(() => import('./nodes/13.js')),
			__memo(() => import('./nodes/14.js')),
			__memo(() => import('./nodes/15.js')),
			__memo(() => import('./nodes/16.js')),
			__memo(() => import('./nodes/17.js')),
			__memo(() => import('./nodes/18.js')),
			__memo(() => import('./nodes/19.js')),
			__memo(() => import('./nodes/20.js')),
			__memo(() => import('./nodes/21.js')),
			__memo(() => import('./nodes/22.js')),
			__memo(() => import('./nodes/23.js')),
			__memo(() => import('./nodes/24.js')),
			__memo(() => import('./nodes/25.js')),
			__memo(() => import('./nodes/26.js')),
			__memo(() => import('./nodes/27.js')),
			__memo(() => import('./nodes/28.js')),
			__memo(() => import('./nodes/29.js'))
		],
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 5 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(module)/account-users",
				pattern: /^\/admin\/account-users\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 7 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(module)/activity-logs",
				pattern: /^\/admin\/activity-logs\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 8 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(module)/dashboard",
				pattern: /^\/admin\/dashboard\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 9 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(auth)/login",
				pattern: /^\/admin\/login\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 6 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(module)/reports",
				pattern: /^\/admin\/reports\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 10 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(module)/roles-permissions",
				pattern: /^\/admin\/roles-permissions\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 11 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(module)/system-settings/mood-tracking",
				pattern: /^\/admin\/system-settings\/mood-tracking\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 12 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(module)/system-settings/questionnaire",
				pattern: /^\/admin\/system-settings\/questionnaire\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 13 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(module)/system-settings/resources",
				pattern: /^\/admin\/system-settings\/resources\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 14 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/(module)/user-profile",
				pattern: /^\/admin\/user-profile\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 15 },
				endpoint: null
			},
			{
				id: "/api/signup",
				pattern: /^\/api\/signup\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/signup/_server.ts.js'))
			},
			{
				id: "/(candidate)/candidate",
				pattern: /^\/candidate\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 16 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(module)/dashboard",
				pattern: /^\/candidate\/dashboard\/?$/,
				params: [],
				page: { layouts: [0,3,4,], errors: [1,,,], leaf: 21 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(module)/history",
				pattern: /^\/candidate\/history\/?$/,
				params: [],
				page: { layouts: [0,3,4,], errors: [1,,,], leaf: 22 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(auth)/login",
				pattern: /^\/candidate\/login\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 17 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(module)/mood-tracking",
				pattern: /^\/candidate\/mood-tracking\/?$/,
				params: [],
				page: { layouts: [0,3,4,], errors: [1,,,], leaf: 23 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(module)/profile",
				pattern: /^\/candidate\/profile\/?$/,
				params: [],
				page: { layouts: [0,3,4,], errors: [1,,,], leaf: 24 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(module)/questionnaire",
				pattern: /^\/candidate\/questionnaire\/?$/,
				params: [],
				page: { layouts: [0,3,4,], errors: [1,,,], leaf: 25 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(module)/questionnaire/instructions",
				pattern: /^\/candidate\/questionnaire\/instructions\/?$/,
				params: [],
				page: { layouts: [0,3,4,], errors: [1,,,], leaf: 26 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(module)/questionnaire/instructions/questions",
				pattern: /^\/candidate\/questionnaire\/instructions\/questions\/?$/,
				params: [],
				page: { layouts: [0,3,4,], errors: [1,,,], leaf: 27 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(module)/resources",
				pattern: /^\/candidate\/resources\/?$/,
				params: [],
				page: { layouts: [0,3,4,], errors: [1,,,], leaf: 28 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(auth)/start-page",
				pattern: /^\/candidate\/start-page\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 18 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(auth)/start-page/data-privacy",
				pattern: /^\/candidate\/start-page\/data-privacy\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 19 },
				endpoint: null
			},
			{
				id: "/(candidate)/candidate/(auth)/start-page/data-privacy/signup-page",
				pattern: /^\/candidate\/start-page\/data-privacy\/signup-page\/?$/,
				params: [],
				page: { layouts: [0,3,], errors: [1,,], leaf: 20 },
				endpoint: null
			},
			{
				id: "/signup",
				pattern: /^\/signup\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 29 },
				endpoint: null
			}
		],
		prerendered_routes: new Set([]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";